import moment from "moment"
import {
  isDuringLastMinute,
  isDuringLastHour,
  isDuringCurrentDay,
} from "./timeHandler"

const DISPLAY_DATE_OPTIONS = {
  month: "long",
  day: "numeric",
  year: "numeric",
}

const SHORT_DISPLAY_DATE_OPTIONS = {
  month: "short",
  day: "numeric",
  year: "numeric",
}

/** Moment/filter display format: Sep 2, 2026 */
export const FILTER_DATE_FORMAT = "MMM D, YYYY"

/** Prose date for UI: September 2, 2026 */
export const formatDisplayDate = (value) => {
  if (!value) return ""
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime()))
    return typeof value === "string" ? value : ""
  return date
    .toLocaleDateString("en-US", DISPLAY_DATE_OPTIONS)
    .replace(/[^ -~]/g, "")
}

/** Machine date for API/form state: 9/2/2026 (matches historical submissions) */
export const formatMachineDate = (value) => {
  if (!value) return ""
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime()))
    return typeof value === "string" ? value : ""
  return date.toLocaleDateString("en-US").replace(/[^ -~]/g, "")
}

/** Short prose date for filters: Sep 2, 2026 */
export const formatShortDisplayDate = (value) => {
  if (!value) return ""
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime()))
    return typeof value === "string" ? value : ""
  return date
    .toLocaleDateString("en-US", SHORT_DISPLAY_DATE_OPTIONS)
    .replace(/[^ -~]/g, "")
}

const isToday = (date) => {
  const today = moment()
  if (date.isSame(today, "d")) return "Today"
}

const isYesterday = (date) => {
  const yesterday = moment().add(-1, "days")
  if (date.isSame(yesterday, "d")) return "Yesterday"
}

const isDuringLastWeek = (date) => {
  const firstDay = moment().add(-2, "days").endOf("day")
  const lastDay = moment().add(-7, "days").startOf("day")

  return date.isBetween(lastDay, firstDay)
}

const isDuringLastYear = (date) => {
  const firstDay = moment().add(-7, "days").endOf("day")
  const startOfYear = moment().startOf("year")

  return date.isBetween(startOfYear, firstDay)
}

export const getMessagesDate = (date) => {
  const takenDate = moment(date)

  if (isToday(takenDate)) return "Today"
  if (isYesterday(takenDate)) return "Yesterday"
  if (isDuringLastWeek(takenDate)) return takenDate.format("dddd")
  if (isDuringLastYear(takenDate)) return takenDate.format("MMMM D")

  return takenDate.format("MMMM D, YYYY")
}

export const getCommentTime = (date) => {
  const takenDate = moment(date)

  if (isDuringLastMinute(takenDate)) return "Recently"
  if (isDuringLastHour(takenDate)) return `${isDuringLastHour(takenDate)} m ago`
  if (isDuringCurrentDay(takenDate)) {
    return takenDate.format("h:mm a")
  }

  if (isYesterday(takenDate)) return "Yesterday"
  if (isDuringLastWeek(takenDate)) return takenDate.format("dddd h:mm a")
  if (isDuringLastYear(takenDate)) return takenDate.format("MMMM D, h:mm a")

  return takenDate.format("MMMM D, YYYY, h:mm a")
}

export const getMessageTime = (date) => {
  const takenDate = moment(date)

  if (isDuringLastMinute(takenDate)) return "Recently"
  if (isDuringLastHour(takenDate)) return `${isDuringLastHour(takenDate)} m ago`
  if (isDuringCurrentDay(takenDate)) {
    return `${isDuringCurrentDay(takenDate)} h ago`
  }

  if (isYesterday(takenDate)) return "Yesterday"
  if (isDuringLastWeek(takenDate)) return takenDate.format("dddd")
  if (isDuringLastYear(takenDate)) return takenDate.format("MMMM D")

  return takenDate.format("MMMM D, YYYY")
}

export const getNotificationDate = (date) => {
  const takenDate = moment(date)
  const time = moment(takenDate).format("hh:mm A")

  if (isToday(takenDate)) {
    return `${time} - Today`
  }

  if (isYesterday(takenDate)) return `${time} - Yesterday`
  if (isDuringLastWeek(takenDate))
    return `${time} - ${takenDate.format("dddd")}`
  if (isDuringLastYear(takenDate)) return takenDate.format("MMMM D")

  return takenDate.format("MMMM D, YYYY")
}
